import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialog as MatDialog, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/models/user';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { HelperService } from 'src/services/helperService';
import { ISchedulingComponent } from '../../i-scheduling.component';
import { RescheduleDialog } from '../reschedule/reschedule.dialog';
import { ICancelAppointmentDialog } from '../cancelAppointment/i-cancel-appointment.dialog';
import { IncadeaBookingService } from 'src/services/api-services/IncadeaBooking.service';
import { IBAppointmentGET } from 'src/services/api-services/api-interfaces/IBAppointmentGET.interface';
import { catchError, Observable, tap } from 'rxjs';

@Component({
    selector: 'app-i-popover-rescheduling',
    templateUrl: './i-popover-rescheduling.component.html',
    styleUrls: ['./i-popover-rescheduling.component.sass'],
    standalone: false
})
export class IPopoverReschedulingComponent implements OnInit {

  userProfile: User;
  isDisabled = false;
  roleId: number = this.helperService.user.role.roleId
  areFiltersLoading: boolean = false; //are filters loading variable
  constructor(@Inject(MAT_DIALOG_DATA) public hoveredData: any,
  public dialog: MatDialog,public incadeaBookingService: IncadeaBookingService,
  public helperService: HelperService,public schedulerService: APISchedulerService,private translate: TranslateService,public dialogRef: MatDialogRef<ISchedulingComponent>) {    this.userProfile = this.helperService.user;}

  ngOnInit(): void {
    // console.log(this.hoveredData)

  }
  onStateChange(value:number){
    const appointmentId=this.hoveredData.AppointmentId

    const clientData = {
      clientFirstName: this.hoveredData.CustomerName.toUpperCase(),
      plate: this.hoveredData.LicenseNo.toUpperCase(),
      typeOfService: this.hoveredData.Services[0].ServiceName.toUpperCase()
    }
    this.incadeaBookingService.UpdateAppointmentStatus(appointmentId, value)
    .subscribe(
      {
        error:(failed)=>{
          // Manejo de error 401
          if (failed.status === 401) {
            this.helperService.logoutToken();
          }

          let messageError = failed.error.text;
          if(messageError=== "Updated successfully")
          {
            const clientNotAssisted =  this.translate.instant('CheckInMsgIncadea',clientData)
                  this.areFiltersLoading = false
                  this.dialogRef.close();
                  this.helperService.showAlert =true
                  this.helperService.typeAlert ="success"
                  this.helperService.messageAlert =clientNotAssisted
                  setTimeout(() => {
                    this.helperService.showAlert =false
                    }, 7000)
            this.dialogRef.close();
          }
          else{
            const clientNotAssisted =  this.translate.instant('ClientNotAssistedIncadea',clientData)
            this.areFiltersLoading = false

            this.helperService.showAlert =true
            this.helperService.typeAlert ="warning"
            this.helperService.messageAlert =clientNotAssisted
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)
      this.dialogRef.close();
          }
          console.log(messageError);

        }

      }

    )
  }


  rescheduleAppointment() {
    const data ={ start: this.hoveredData.Start,
      end: this.hoveredData.End,
      dataItem: this.hoveredData}


    const dialogRef=
    this.dialog.open(RescheduleDialog,{
      width: '903px',
      panelClass: "icon-outside",
      data
    })
    dialogRef.afterClosed().subscribe((result)=>{
      if (result) {
        this.dialogRef.close(true);
      }})
    //
  }

  cancelAppointment() {
    // this.hoveredData.Token = this.tokenString
    const data ={ start: this.hoveredData.Start,
      end: this.hoveredData.End,
      dataItem: this.hoveredData}
data.dataItem.Token = this.hoveredData.token

const dialogRef=this.dialog.open(ICancelAppointmentDialog, {
      width: '525px',
      panelClass: 'icon-outside',
      data: data
    })
    dialogRef.afterClosed().subscribe((result)=>{
      if (result) {
        this.dialogRef.close(true);
      }})

  }
  onCancel(){this.dialogRef.close();}


}
